import { Result } from "antd";
import { userAtom } from "@iso/state";
import { useRecoilValue } from "recoil";
import { Redirect, useHistory } from "react-router-dom";
import { Button } from "../../../node_modules/antd/lib/index";

function Auth() {
   const user = useRecoilValue(userAtom);
   const history = useHistory();
   return (
      <>
         {console.log(user)}
         {!user?.isLogin ? (
            <Redirect
               to={{
                  pathname: "/login",
               }}
            />
         ) : !user?.info?.id ? (
            <div className="min-h-screen flex items-center justify-center">
               <Result
                  status="warning"
                  title={
                     <>
                        <p className="text-primary-500 opacity-75 text-2xl">
                           You're not invited into the system.
                        </p>
                        <Button onClick={() => history.push("/login")}>
                           Try again with another account
                        </Button>
                     </>
                  }
               />
            </div>
         ) : !user?.info?.firebase_user_id ? (
            <Redirect
               to={{
                  pathname: "/register",
               }}
            />
         ) : (
            <Redirect
               to={{
                  pathname: "/choose-system",
               }}
            />
         )}
      </>
   );
}

export default Auth;
